import React from 'react';
import { Cascader, Form, Input } from 'antd';
import RadioTags from '../../../components/RadioTags';

class PredefinedTemplateFields extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      game_list: [],
      game_obj: null
    }
  }

  componentDidMount() {
    // 预处理，将area和server转换为级联选择组件所需格式
    let game_list = this.props.template.game_list;
    game_list = game_list ? [...game_list] : [];
    game_list.forEach(game => {
      if (game.area_list) {
        game.area_list.forEach(area => {
          if (area.server_list)
            area.children = area.server_list;
        })
      }
    });

    // 设置game初始值
    this.setState({game_list}, () => {
      if (game_list.length > 0) {
        if (game_list[0].value)
          this.handleGameChanged(game_list[0].value);
        else
          this.setState({game_obj: game_list[0]});
      }
    });
  }

  getFieldsValue = () => {
    let values = this.formRef.getFieldsValue();
    const {area_server} = values;
    if (area_server) {
      values.area = area_server.length > 0 ? area_server[0] : null;
      values.server = area_server.length > 1 ? area_server[1] : null;
      delete values.area_server;
    }
    return values;
  }

  validateFields = () => {
    return this.formRef.validateFields();
  }

  resetFields = () => {
    this.formRef && this.formRef.resetFields();
  }

  handleGameChanged = (value) => {
    const previous_game = this.formRef.getFieldValue('game');

    // 设置game
    this.formRef && this.formRef.setFieldsValue({game: value});

    // 重置各项值
    if (previous_game !== value) {
      this.formRef && this.formRef.setFieldsValue({
        charge_account_type: null,
        charge_mode: null,
        area: null,
        server: null
      })
    }

    // 设置game_obj
    this.state.game_list.forEach(game => {
      if (game.value === value) {
        this.setState({
          game_obj: game
        });
      }
    })
  }

  render() {
    let {game_obj, game_list} = this.state;

    return <Form ref={form => this.formRef = form} layout='vertical'
                 className='form-compact' requiredMark={false}>
      {
        game_list.length === 0 && this.rechargeAccountField()
      }
      {
        game_list.length === 1 &&
        <Form.Item name='game' value={this.state.game} hidden>
          <Input/>
        </Form.Item>
      }
      {
        game_list.length > 1 &&
        <>
          <Form.Item name='game' label='游戏' rules={[{required: true, message: '请选择游戏'}]}>
            <RadioTags options={game_list} onChange={this.handleGameChanged}/>
          </Form.Item>
        </>
      }
      {
        game_obj && game_obj.charge_account_type_list && game_obj.charge_account_type_list.length > 0 &&
        <Form.Item name='charge_account_type' label='账号类型' rules={[{required: true, message: '请选择账号类型'}]}>
          <RadioTags options={game_obj.charge_account_type_list}/>
        </Form.Item>
      }
      {
        game_obj && game_obj.charge_mode_list && game_obj.charge_mode_list.length > 0 &&
        <Form.Item name='charge_mode' label='充值方式' rules={[{required: true, message: '请选择充值方式'}]}>
          <RadioTags options={game_obj.charge_mode_list}/>
        </Form.Item>
      }
      {
        game_obj && game_obj.area_list && game_obj.area_list.length > 0 &&
        <Form.Item name='area_server' label='区服' rules={[{required: true, message: '请选择区服'}]}>
          <Cascader placeholder='输入区服名称搜索' showSearch options={game_obj.area_list}
                    style={{width: 300}}
                    onChange={this.handleAreaServerCascaderChanged}/>
        </Form.Item>
      }
      {
        game_obj && this.rechargeAccountField(game_obj.charge_account_name)
      }
    </Form>
  }

  rechargeAccountField = (label = null) => {
    label = label ? label : '充值账号';
    const message = `请输入${label}`;
    return <Form.Item
      label={label}
      name='charge_account'
      rules={[{required: true, message: {message}}]}
    >
      <Input style={{width: 200}}/>
    </Form.Item>
  }
}

export default PredefinedTemplateFields;